export const normalizeTemplateName = (value) =>
  String(value ?? '').toLowerCase().replace(/\//g, 'or').replace(/\s+/g, '');

const matchingValue = (data, requested) => {
  if (!data || !requested) return null;
  const keys = Object.keys(data);
  const key = keys.find(key => key === requested) ??
    keys.find(key => normalizeTemplateName(key) === normalizeTemplateName(requested));
  return key === undefined ? null : data[key];
};

export const selectInvitationTemplates = (catalog, categoryName, eventName) => {
  const fallback = matchingValue(matchingValue(catalog, 'default'), 'default');
  // The event master calls this category "Birthdays"; template assets use "Birthday".
  const category = matchingValue(catalog, categoryName) ||
    (normalizeTemplateName(categoryName) === 'birthdays' ? matchingValue(catalog, 'Birthday') : null);
  const selected = matchingValue(category, eventName);
  return selected && Array.isArray(selected.images) ? selected : fallback || null;
};

// The editable event title may be a person's name. Templates follow the master
// event type, which is also used when displaying the saved invitation publicly.
export const invitationTemplateEventName = (event) =>
  event?.EventMasterDetails?.eventName || event?.eventTitle || '';
